import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GAPageInfo, GAUserInfo} from '../../types/analyticsTypes';
import {generatePageAndSection} from '../../utils/analyticsUtils';

interface AnalyticsState {
  prevPage: GAPageInfo;
  user: GAUserInfo;
  report_src?: string;
}

const initialState: AnalyticsState = {
  prevPage: {
    name: '',
    section: '',
    prev_page_name: '',
    prev_page_url: '',
  },
  user: {
    id: '',
    company_id: '',
    role: '',
    category: '',
    primary_role: '',
  },
  report_src: '',
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setPrevPage(state, action: PayloadAction<string>) {
      if (state.prevPage) {
        state.prevPage.prev_page_url = action.payload;
        state.prevPage.prev_page_name = generatePageAndSection(
          action.payload
        ).page;
      }
    },
    setUserRole(state, action: PayloadAction<string>) {
      state.user.role = action.payload;
    },
    setReportSrc(state, action: PayloadAction<string>) {
      state.report_src = action.payload;
    },
    setUserDetailsGA(state, action: PayloadAction<GAUserInfo>) {
      if (action.payload) {
        state.user.id = action.payload.id;
        state.user.company_id = action.payload.company_id;
        state.user.category = action.payload.category;
      }
    },
    resetAnalyticUserState(state) {
      state.user = initialState.user;
    },
  },
});

export const {
  setPrevPage,
  setUserRole,
  setUserDetailsGA,
  resetAnalyticUserState,
  setReportSrc,
} = analyticsSlice.actions;
export default analyticsSlice.reducer;
